var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObecnnvod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07227 14.5357L14.9294 14.5357L14.9294 16.8928L7.07227 16.8928L7.07227 14.5357Z",
    fill: "#22E06C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7849 0.392883V8.64288H20.0349V11H9.42773V0.392883H11.7849Z",
    fill: "#22E06C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57227 0H11.8881L20.4294 8.69596V22H1.57227V0ZM3.92941 2.35714V19.6429H18.0723V9.65995L10.8993 2.35714H3.92941Z",
    fill: "#22E06C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObecnnvod);
export default __webpack_public_path__ + "static/media/Obecný návod.f390691c7a936dfef851507a4c3b90a9.svg";
export { ForwardRef as ReactComponent };